export const HEADER_HEIGHT = '50px';

export const HEADER_BACKGROUND_COLOR_DROPDOWN = 'rgb(255 255 255)';
